import {orderPath} from 'src/shared/utils'

export const Names = {
  VERTICALS: orderPath('offerFlow'),
  BUSINESS_TOGGLE: orderPath('isBusiness'),
  DESTINATION_POINT_NDD: orderPath('destinationPoints.0'),
  DESTINATION_POINTS: orderPath('destinationPoints'),
  PARCEL: orderPath('destinationPoints.0.parcels.0'),
  OFFERS: orderPath('offerFlow'),
  PAYMENT_METHOD: orderPath('paymentMethod'),
  PAYMENT_INFO: orderPath('paymentInfo'),
  NDD_ROUTE: orderPath('ndd.route'),
} as const
